<div class="ai-post-action-dialog">
  <div class="ai-post-action-dialog__icon" [class]="'ai-post-action-dialog__icon--' + variant">
    <span aria-hidden="true">{{ iconGlyph }}</span>
  </div>

  <h2 class="ai-post-action-dialog__title">{{ title }}</h2>
  <p class="ai-post-action-dialog__message">{{ message }}</p>

  @if (steps.length) {
    <ol class="ai-post-action-dialog__steps">
      @for (step of steps; track step) {
        <li>{{ step }}</li>
      }
    </ol>
  }

  <button type="button" class="ai-post-action-dialog__btn" (click)="close()">
    {{ confirmLabel }}
  </button>
</div>
